import { Routes, Route } from 'react-router-dom';
import { NotFoundPage } from '@/pages/NotFoundPage';
import HomeLayout from './layouts/HomeLayout';
import {
  HomePage,
  SportsPage,
  CasinoGames,
  GameDetailsPage,
  BetProfitLossPage,
  BetHistoryPage,
  UnsettledBetPage,
  StakeSettingsPage,
  RulesPage,
  ChangePasswordPage,
  AccountStatementPage,
  ResultsPage,
  InplayPage,
  RacingPage,
  RacingInside,
} from '@/routes';
import ModalManager from './components/ModalManager';
import { ProtectedRoute } from './components/common/ProtectedRoute';
const sportsRoutes = ['Cricket', 'Football', 'Tennis'];

export function App() {
  return (
    <>
      <Routes>
        {/* Protected Routes */}
        <Route element={<HomeLayout />}>
          <Route path="/" element={<HomePage />} />
          {/* <Route path="/" element={<HomePageLogin />} /> */}
          <Route path="/sports" element={<SportsPage />} />
          <Route path="/LIVECASINO" element={<CasinoGames />} />
          <Route path="/inplay" element={<InplayPage />} />
          {sportsRoutes.map((sport) => {
            const sportPath = sport.toLowerCase();
            return (
              <Route key={sport}>
                <Route path={`/sports/${sportPath}`} element={<InplayPage sportName={sport} />} />
                <Route
                  path={`/sports/${sportPath}/:competitionId`}
                  element={<InplayPage sportName={sport} />}
                />
                <Route
                  path={`/sports/${sportPath}/market-details/:eventId`}
                  element={<GameDetailsPage sportName={sport} />}
                />
              </Route>
            );
          })}
          <Route path="/racing/:sportName" element={<RacingPage />} />
          <Route path="/racing/:sportName/:competitionId" element={<RacingPage />} />
          <Route path="/details/:game/:eventId/:gameId" element={<RacingInside />} />
          <Route path="/details/:game/:eventId" element={<RacingInside />} />

          <Route element={<ProtectedRoute />}>
            <Route path="/account-statement" element={<AccountStatementPage />} />
            <Route path="/bet-history" element={<BetHistoryPage />} />
            <Route path="/unsettled-bet" element={<UnsettledBetPage />} />
            <Route path="/profit-loss" element={<BetProfitLossPage />} />
            <Route path="/stake-settings" element={<StakeSettingsPage />} />
            <Route path="/change-password" element={<ChangePasswordPage />} />
          </Route>
          <Route path="/rules" element={<RulesPage />} />
          <Route path="/results" element={<ResultsPage />} />
        </Route>

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      {/* Global modal renderer — controlled via Redux dispatch(openModal('login')) */}
      <ModalManager />
    </>
  );
}
